var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('b-pagination-nav',{attrs:{"use-router":"","number-of-pages":10,"link-gen":_vm.linkGen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }